const EXTERIOR_HYPHEN = /\b(Field|Well|Battle)-(Tested|Worn|Scarred)\b/g;

// WHY: в текстах статей название износа рвалось на «Well- / Worn»; дефис в нём заменяем на неразрывный U+2011, сам content не трогаем
export const keepExteriorNames = (text: string): string => text.replace(EXTERIOR_HYPHEN, '$1‑$2');

const SHORT_WORD = /(?<=^|[\s(«„"])(\p{L}{1,2}) /gu;
const NUMBER_RANGE = /(\d)–(\d)/g;
const BEFORE_RANGE = / (?=\d[\d.,]*⁠–)/g;

// WHY: типограф при выводе: предлог или союз из одной-двух букв не остаётся в конце строки («В / июне»), тире и «|» в названии не начинают строку, диапазон «1–4» не рвётся и не отрывается от слова перед ним («Phase 1–4»); content не трогаем
export const wikiProse = (text: string): string =>
  keepExteriorNames(text)
    .replace(SHORT_WORD, '$1 ')
    .replace(/ —/g, ' —')
    .replace(/ \|/g, ' |')
    .replace(NUMBER_RANGE, '$1⁠–⁠$2')
    .replace(BEFORE_RANGE, ' ');
